import React from 'react';

export default function useDrawerState({
  onClose = () => {},
  onOpen = () => {},
} = {}) {
  const [open, setOpen] = React.useState(false);

  const handleClose = () => {
    setOpen(false);
    onClose();
  };

  const handleOpen = () => {
    setOpen(true);
    onOpen();
  };

  const toggleDrawer = () => {
    setOpen(prev => {
      if (prev) {
        onClose();
      } else {
        onOpen();
      }
      return !prev;
    });
  };

  return {
    handleClose,
    handleOpen,
    toggleDrawer,
    open,
  };
}
